// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customizableBtn[data-v-d281f21a] {\n  margin-inline: 10px;\n}", ""]);
// Exports
module.exports = exports;
